import {
  ReferenceDataResponseType,
  ReferenceDataServiceParams
  // SpecialityModel,
  // SpecialityListResponse,
  // SubSpecialityModel,
  // SubSpecialityListResponse
} from './service-mappers/ReferenceDataMapper';
import {ServiceSuccessResponseType} from './service-mappers/BaseMapper';
import {AxiosCall} from '../axios';
import {environment} from '../environment/environment';
import {ArrayResponse} from './service-mappers/CommonServiceMapper';
// import {serializeQueryParams} from './PaymentHistoryService';

const referenceUrl = environment.apiEndPoints.reference.base;

export const referenceDataService = (
  params: ReferenceDataServiceParams
): Promise<
  ServiceSuccessResponseType<ArrayResponse<ReferenceDataResponseType>>
> => {
  const url = referenceUrl + `/${params.key}`;
  return AxiosCall.get(url);
};

export const referenceFileDataService = (
  params: ReferenceDataServiceParams
): Promise<
  ServiceSuccessResponseType<ArrayResponse<ReferenceDataResponseType>>
> => {
  const url = referenceUrl + `/${params.key}`;
  return AxiosCall.getFileData(url);
};

// ==================== Specialities ====================

// export const fetchAllSpecialities = (params?: {
//   limit?: number;
//   offset?: number;
//   search_text?: string;
// }): Promise<ServiceSuccessResponseType<SpecialityListResponse>> => {
//   const queryString = serializeQueryParams(params);
//   const url = `/reference-data/speciality${
//     queryString ? `?${queryString}` : ''
//   }`;
//   return AxiosCall.get(url);
// };

// export const fetchSpecialityById = (
//   id: number
// ): Promise<ServiceSuccessResponseType<SpecialityModel>> => {
//   return AxiosCall.get(`/reference-data/speciality/${id}`);
// };

// ==================== Sub-Specialities ====================

// export const fetchAllSubSpecialities = (params?: {
//   limit?: number;
//   offset?: number;
//   search_text?: string;
//   speciality_id?: number;
// }): Promise<ServiceSuccessResponseType<SubSpecialityListResponse>> => {
//   const queryString = serializeQueryParams(params);
//   const url = `/reference-data/sub-speciality${
//     queryString ? `?${queryString}` : ''
//   }`;
//   return AxiosCall.get(url);
// };

// export const fetchSubSpecialityById = (
//   id: number
// ): Promise<ServiceSuccessResponseType<SubSpecialityModel>> => {
//   return AxiosCall.get(`/reference-data/sub-speciality/${id}`);
// };
